module Meevo.Plugins.Register {
    "use strict";

    export class AutomaticDiscountsSection extends Meevo.Plugins.Register.RegisterSectionBase {

        public automaticDiscounts: any[] = [];
        private isEditing: boolean = false;

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get busyService() { return this.registerContext.busyService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.AutomaticDiscounts, registerContext, "automaticDiscounts", Register.RegisterSectionCatTypeEnum.Other);
        }

        reset() {
            this.initialize(this.registerContext.sale);
        }

        cancel() {
            if (device.portrait()) {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Ticket);
            } else {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
            }
        }

        private initialize(sale: Model.Sale) {
            if (sale) {
                this.getAutomaticDiscounts(sale);
                this.isEditing = true;
            }
        }

        discountSelect(discountItem, isApplied) {
            if (isApplied) {
                this.removeDiscount(discountItem);
            } else {
                this.applyDiscount(discountItem);
            }
        }

        private applyDiscount(discountItem) {
            if (!!this.registerContext.sale.removedAutomaticDiscountIds) {
                var ndx = _.findIndex(this.registerContext.sale.removedAutomaticDiscountIds, (item) => item == discountItem.id);
                if (ndx >= 0) {
                    this.registerContext.sale.removedAutomaticDiscountIds.splice(ndx, 1);
                }
            }
            this.registerContext.sale.automaticDiscountIdToBeApplied = discountItem.id;
            this.busyService.start();
            this.registerContext.recalculateSale().then(() => {
                discountItem.isApplied = true;
                // refresh to get updated strings for "applied to" and "eligible items"
                this.getAutomaticDiscounts(this.registerContext.sale);
            });
        }

        private removeDiscount(discountItem) {
            if (!this.registerContext.sale.removedAutomaticDiscountIds) {
                this.registerContext.sale.removedAutomaticDiscountIds = [];
            }
            this.registerContext.sale.removedAutomaticDiscountIds.push(discountItem.id);
            this.busyService.start();
            this.registerContext.recalculateSale().then(() => {
                discountItem.isApplied = false;
                // refresh to get updated strings for "applied to" and "eligible items"
                this.getAutomaticDiscounts(this.registerContext.sale);
            });
        }

        private getAutomaticDiscounts(sale: Model.Sale) {
            this.busyService.start();
            return this.dataService.customMethodData("api/sale/automaticDiscounts/list", "POST", sale)
                .then((response) => {
                    this.automaticDiscounts = response.data.automaticDiscounts;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }
    }
}
